/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import AppHeader from '../commons/header/app'

const AdminLayout = (props: any) => {
  return (
    <React.Fragment>
      <div>
        <AppHeader />
        <section className='flex flex-col overflow-y-auto p-6 md:px-12 lg:px-12'>
          {props.children}
        </section>
      </div>
    </React.Fragment>
  )
}

export default AdminLayout
